export default __webpack_public_path__ + "static/media/CustomizedSolutions2.eb952aad.jpg";